import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    userInfo: {},
    companyInfo:{},
    accountDate:'' , //当前账期
    startDate: '', // 启用账期
    homeInfo:{},
    acctCompanyInfo:{},
    accountHomeInfo:{},
    wechatCollectionInfo:{},
    realityMonthfeeInfo:{},
    dueAmountDateInfo:{
      beginDate:'',
      endDate:''
    },
    collectionTypeInfo:{
      AmountList:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      discount:0,
      serviceFee:0
    },
    lackFeeAmount:0,
    powerData:[],
    fromAcctCustomerInfo:{},
    businessServiceInfo:{},
    taxUrl: ''
  },
  mutations: {
    isLogin(state, isLogin) {
      state.isLogin = isLogin
    },
    userInfo(state,info){
      state.userInfo = info;
    },
    powerData(state,info){
      state.powerData = info;
    },
    companyInfo(state,info){ 
      state.companyInfo = info;
    },
    logout(state) {
      state.isLogin = false
      state.userInfo = {}
      state.companyInfo = {}
      state.accountDate = ''
    },
    accountDate(state,info){ 
      state.accountDate = info;
    },
    startDate(state, info) {
      state.startDate = info
    },
    updateStaffInfo(state, info) {
      state.userInfo.staff = info
    },
    updateStaffInfoStaffId(state, info) {
      state.userInfo.staff.staffId = info
    },
    homeInfo(state,info){ 
      state.homeInfo = info;
    },
    acctCompanyInfo(state,info){ 
      state.acctCompanyInfo = info;
    },
    accountHomeInfo(state,info){ 
      state.accountHomeInfo = info;
    },
    wechatCollectionInfo(state,info){ 
      state.wechatCollectionInfo = info;
    },
    fromAcctCustomerInfo(state,info){ 
      state.fromAcctCustomerInfo = info;
    },
    businessServiceInfo(state,info){ 
      state.businessServiceInfo = info;
    },
    realityMonthfeeInfo(state,info){ 
      state.realityMonthfeeInfo = info;
    },
    dueAmountDateInfo(state,info){ 
      state.dueAmountDateInfo = info;
    },
    collectionTypeInfo(state,info){ 
      state.collectionTypeInfo = info;
    },
    lackFeeAmount(state,info){ 
      state.lackFeeAmount = info;
    },
    allReceivale(state, info){
      state.allReceivale = info
    },
    taxUrl(state, info){
      state.taxUrl = info
    },
  },
  actions: {
    setUserInfo(context,info){   //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性，info为要变化的形参
      context.commit('userInfo',info)
    },
    setPowerData(context,info){
      context.commit('powerData',info)
    },
    setCompanyInfo(context,info){   
      context.commit('companyInfo',info)
    },
    setLoginState(context, isLogin) {
     context.commit('isLogin', isLogin)
    },
    logout(context) {
      context.commit('logout')
    },
    setAccountDate(context,info){   
      context.commit('accountDate',info)
    },
    setStartDate(context, info) {
      context.commit('startDate', info)
    },
    updateStaff(context, info){
      context.commit('updateStaffInfo',info)
    },
    updateStaffInfoStaffIdFun(context, info){
      context.commit('updateStaffInfoStaffId',info)
    },
    setHomeInfo(context,info){   
      context.commit('homeInfo',info)
    },
    setAcctCompanyInfo(context,info){   
      context.commit('acctCompanyInfo',info)
    },
    setAccountHomeInfo(context,info){   
      context.commit('accountHomeInfo',info)
    },
    setWechatCollectionInfo(context,info){   
      context.commit('wechatCollectionInfo',info)
    },
    setFromAcctCustomerInfo(context,info){   
      context.commit('fromAcctCustomerInfo',info)
    },
    setBusinessServiceInfo(context,info){   
      context.commit('businessServiceInfo',info)
    },
    setRealityMonthfeeInfo(context,info){   
      context.commit('realityMonthfeeInfo',info)
    },
    setDueAmountDateInfo(context,info){   
      context.commit('dueAmountDateInfo',info)
    },
    setCollectionTypeInfo(context,info){   
      context.commit('collectionTypeInfo',info)
    },
    setLackFeeAmount(context,info){   
      context.commit('lackFeeAmount',info)
    },
    setAllReceivale(context,info){
      context.commit('allReceivale',info)
    },
    setTaxUrl(context,info){
      context.commit('taxUrl',info)
    },
  }
})
